import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";

const Battery_report_view = () => {
  useAuthRedirect();
  const { id } = useParams();
  const [loading, setLoading] = useState(true); 
  const [batteryData, setBatteryData] = useState(null); 

  const canView  = hasPermission("Battery Card Maintenance", "view");

  useEffect(() => {
    if (id) {
      fetchBatteryDetails();
    }
  }, [id]);

  const fetchBatteryDetails = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/report_fetch/${id}`);
      console.log("Fetched Battery Data:", response.data);

      if (response.data && response.data.position) {
        setBatteryData(response.data.position); 
      } else {
        console.warn("No position data found in API response.");
      }
    } catch (error) {
      console.error("Error fetching battery details:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Battery Report View</h2>
          <Link to='/battery_transaction_view'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle</th>
                <th>Battery Code</th>
                <th>Battery Type</th>
                <th>Fitted Date</th>
                <th>Purchase From</th>
                <th>Life</th>
                <th>Removed Date</th>
                <th>Reason</th>
                <th>Remark</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : batteryData ? ( // Check if batteryData exists
                <tr>
                  <td>1</td> {/* Static since only one record is shown */}
                  <td>{batteryData.vehicle}</td>
                  <td>{batteryData.battery_code}</td>
                  <td>{batteryData.battery_type}</td>
                  <td>{new Date(batteryData.fitted_date).toLocaleDateString()}</td>
                  <td>{batteryData.purchase_from || "N/A"}</td>
                  <td>{batteryData.life || "N/A"}</td>
                  <td>{batteryData.removed_date ? new Date(batteryData.removed_date).toLocaleDateString() : "N/A"}</td>
                  <td>{batteryData.reason || "N/A"}</td>
                  <td>{batteryData.remark || "N/A"}</td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="10">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Battery_report_view;
